import gql from 'graphql-tag';
const DOLCH_SPACE_ACTIVITY_FRAGMENT = gql `
  fragment DolchSpaceActivityFragment on DolchSpaceActivity {
    subtitle
    rounds {
      roundIndex
      image
      optionalAudio: audio
      phrase
      imageBefore
      steps {
        stepIndex
        answer
      }
    }
  }
`;
export default DOLCH_SPACE_ACTIVITY_FRAGMENT;
